/** Shared type for name+date entities (Region, Territory, Zone). */
export type EntityItem = {
  id: string;
  name: string;
  isActive?: boolean;
  createdAt: string;
  updatedAt: string;
};

/** API contract for list/create/update/delete. */
export type EntityApi = {
  getList: () => Promise<{ data?: EntityItem[] }>;
  create: (data: { name: string }) => Promise<unknown>;
  update: (id: string, data: { id?: string; name: string }) => Promise<unknown>;
  delete: (id: string) => Promise<{ status?: number }>;
};

/** Labels derived from entity name (e.g. "Zone" -> "Manage Zones", "Failed to delete zone"). */
export type EntityLabels = {
  /** Singular title case, e.g. "Zone", "Region" */
  entityName: string;
  /** Optional plural for "Manage X" (defaults to entityName + "s") */
  entityNamePlural?: string;
};

export function getEntityLabels(labels: EntityLabels) {
  const singular = labels.entityName;
  const plural = labels.entityNamePlural ?? `${singular}s`;
  const singularLower = singular.toLowerCase();
  return {
    manageTitle: `Manage ${plural}`,
    addButton: `Add ${singular}`,
    createButton: `Create ${singular}`,
    updateButton: `Update ${singular}`,
    editTitle: `Edit ${singular}`,
    createTitle: `Create ${singular}`,
    deleteTitle: `Delete ${singular}`,
    deletedSuccess: `${singular} deleted successfully`,
    deleteFailed: `Failed to delete ${singularLower}`,
    addedToast: `${singular} added`,
    updatedToast: `${singular} updated`,
  };
}
